import Vue from 'vue'
import VueRouter from 'vue-router'

// 导入需要的路由组件
import Main from '@/views/Main/Main.vue'
import Login from '@/views/Login/Login.vue'
import FindPassword from '@/views/FindPassword/FindPassword.vue'
import Register from '@/views/Register/Register.vue'
import User from '@/views/User/User.vue'
import Home from '@/views/Home/Home.vue'
import Recruit from '@/views/Recruit/Recruit.vue'
import Celebrity from '@/views/Celebrity/Celebrity.vue'
import DataDownload from '@/views/DataDownload/DataDownload.vue'
import Information from '@/views/Information/Information.vue'
import Journal from '@/views/Journal/Journal.vue'
import Train from '@/views/Train/Train.vue'
import CollegeLibrary from '@/views/CollegeLibrary/CollegeLibrary.vue'
import Policy from '@/views/Policy/Policy.vue'
import Protocol from '@/views/Protocol/Protocol.vue'
import Contact from '@/views/Contact/Contact.vue'
import Lines from '@/views/Lines/Lines.vue'
import Sign from '@/views/Sign/Sign.vue'
import Introduction from '@/views/Introduction/Introduction.vue'
import Major from '@/views/Major/Major.vue'
import Nation from '@/views/Nation/Nation.vue'
import Department from '@/views/Department/Department.vue'
import Article from '@/views/Article/Article.vue'

// 导入 vuex 模块
import store from '@/store/index.js'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

// 路由规则
const routes = [
  { path: '/login', component: Login, name: 'Login' },
  { path: '/findpassword', component: FindPassword, name: 'FindPassword' },
  { path: '/register', component: Register, name: 'Register' },
  { path: '/user', component: User, name: 'User' },
  { path: '/policy', component: Policy, name: 'Policy' },
  { path: '/protocol', component: Protocol, name: 'Protocol' },
  {
    path: '/',
    component: Main,
    children: [
      {
        path: '/',
        component: Home,
        name: 'Home',
        meta: { isRecord: true, top: 0 }
      },
      {
        path: '/recruit',
        component: Recruit,
        name: 'Recruit',
        meta: { isRecord: true, top: 0 }
      },
      {
        path: '/celebrity',
        component: Celebrity,
        name: 'Celebrity',
        meta: { isRecord: true, top: 0 }
      },
      {
        path: '/datadownload',
        component: DataDownload,
        name: 'DataDownload',
        meta: { isRecord: true, top: 0 }
      },
      {
        path: '/information',
        component: Information,
        name: 'Information',
        meta: { isRecord: true, top: 0 }
      },
      {
        path: '/journal',
        component: Journal,
        name: 'Journal',
        meta: { isRecord: true, top: 0 }
      },
      {
        path: '/major',
        component: Major,
        name: 'Major',
        meta: { isRecord: true, top: 0 }
      },
      {
        path: '/article',
        component: Article,
        name: 'Article',
        meta: { isRecord: true, top: 0 }
      },
      {
        path: '/lines',
        component: Lines,
        name: 'lines',
        meta: { isRecord: true, top: 0 }
      },
      {
        path: '/sign',
        component: Sign,
        name: 'sign',
        meta: { isRecord: true, top: 0 }
      },
      {
        path: '/department',
        component: Department,
        name: 'Department',
        meta: { isRecord: true, top: 0 }
      },
      {
        path: '/nation',
        component: Nation,
        name: 'Nation',
        meta: { isRecord: true, top: 0 }
      },
      {
        path: '/introduction',
        component: Introduction,
        name: 'introduction',
        meta: { isRecord: true, top: 0 }
      },
      {
        path: '/train',
        component: Train,
        name: 'Train',
        meta: { isRecord: true, top: 0 }
      },
      {
        path: '/collegelibrary',
        component: CollegeLibrary,
        name: 'CollegeLibrary',
        meta: { isRecord: true, top: 0 }
      },
      {
        path: '/contact',
        component: Contact,
        name: 'Contact',
        meta: { isRecord: true, top: 0 }
      }
    ]
  }
]

// 创建路由的实例对象
const router = new VueRouter({
  base: '/',
  mode: 'history', // hash或者history
  routes
})

// 所有有权限页面的路径，都在这个数组之中
const pagePathArr = ['/user']

// 为路由的实例对象挂载全局前置守卫
router.beforeEach((to, from, next) => {
  // 访问的是有权限的页面，需要判断用户是否登录
  if (pagePathArr.indexOf(to.path) !== -1) {
    // 1. 从 store 中获取 tokenCustomer 的值
    //    注意：store.state.tokenCustomer 要么是 {} 空对象，要么是包含 {token, refresh_token} 的对象
    const tokenStr = store.state.tokenCustomer.token
    if (tokenStr) {
      // token 有值，已登录过（操作：直接放行）
      next()
    } else {
      // token 不存在，没有登录（操作：强制跳转到登录页），并携带路由的 "query 查询参数"
      next(`/login?pre=${to.fullPath}`)
    }
  } else {
    // 访问的是没有权限的页面
    next()
  }
})

// 全局后置钩子
router.afterEach((to, from) => {
  // 如果当前的路由的元信息中，isRecord 的值为 true
  if (to.meta.isRecord) {
    setTimeout(() => {
      // 则把元信息中的 top 值设为滚动条纵向滚动的位置
      window.scrollTo(0, to.meta.top)
    }, 0)
  }
})

export default router
